import Company from '@/models/Company'
import { company as backend } from '@/api'
import { groupBy, last } from 'lodash'

export default {

  namespaced: true,

  state: {
    company: new Company,
  },

  mutations: {
    set: (state, payload) => state.company = payload,
    setLogo: (state, payload) => state.company.logo_url = payload,
    legalName: (state, payload) => state.company.legal_name = payload,
    tradingName: (state, payload) => state.company.trading_name = payload,
    telephone: (state, payload) => state.company.telephone = payload,
    vatNumber: (state, payload) => state.company.vat_number = payload,
    registrationNumber: (state, payload) => state.company.registration_number = payload,
    isSetup: (state) => state.company.is_setup = true,
    toggleSearchable: (state) => state.company.is_searchable = !state.company.is_searchable,
  },

  actions: {
    save: ({state, commit}) => new Promise((resolve, reject) => {
      backend.save(state.company, response => {
        commit('isSetup')
        resolve(response)
      }, error => reject(error))
    }),
    loadActiveCompany: ({commit}) => new Promise((resolve, reject) => {
      backend.loadActiveCompany(response => {
        commit('set', response.data)
        resolve()
      }, error => reject(error))
    }),
    uploadLogo: ({commit}, file) => new Promise((resolve, reject) => {
      backend.uploadLogo(file, ({data}) => {
        commit('setLogo', data)
        resolve()
      }, error => reject(error))
    }),
    loadNotificationChannels: ({commit}) => new Promise((resolve, reject) => {
      backend.loadNotificationChannels(({data}) => {
        commit('setNotificationChannels', data)
        resolve()
      }, error => reject(error))
    }),
    toggleSearchable: ({commit}) => new Promise((resolve, reject) => {
      commit('toggleSearchable')
      backend.toggleSearchable(({data}) => {
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    company: state => state.company,
  }

}
